import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, toHandlers as _toHandlers, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { shallowRef, onMounted, watch, computed } from "vue";
import { useComponentFactory } from "@/composables/useComponentFactory";

interface Props {
  identifier: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ComponentFactory',
  props: {
    identifier: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const { createComponent } = useComponentFactory();

const currentComponent = shallowRef(null);

const currentProperties = computed(() => {
  switch (currentComponent.value) {
    default:
      return {};
  }
});

const currentListeners = computed(() => {
  switch (currentComponent.value) {
    default:
      return {};
  }
});

onMounted(() => {
  currentComponent.value = createComponent(props.identifier);
});

watch(
  () => props.identifier,
  (newIdentifier) => {
    currentComponent.value = null;
    currentComponent.value = createComponent(newIdentifier);
  },
  { immediate: true }
);

__expose({
  currentComponent,
  currentProperties,
  currentListeners,
});

return (_ctx: any,_cache: any) => {
  return (currentComponent.value)
    ? (_openBlock(), _createBlock(_resolveDynamicComponent(currentComponent.value), _mergeProps({ key: 0 }, currentProperties.value, _toHandlers(currentListeners.value)), null, 16))
    : _createCommentVNode("", true)
}
}

})